import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHappyEmotion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#FFB03D" d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10" />
    <path
      fill="#00265D"
      stroke="#00265D"
      strokeWidth={0.043}
      d="M8.508 8.373a.4.4 0 0 1-.012.203.18.18 0 0 1-.09.101.4.4 0 0 1-.162.034 1.3 1.3 0 0 1-.218-.017q-.145-.024-.303-.058l-.22-.044a1.7 1.7 0 0 0-.514-.035c-.153.021-.338.093-.528.177l-.191.085a8 8 0 0 1-.38.165c-.184.071-.346.115-.468.098a.23.23 0 0 1-.146-.07.34.34 0 0 1-.076-.19.82.82 0 0 1 .127-.523c.1-.171.25-.334.421-.477.344-.287.774-.494 1.069-.534s.693.053 1.032.247.611.485.66.838ZM11.536 8.373a.4.4 0 0 0 .011.203q.029.07.091.101a.4.4 0 0 0 .162.034q.098.002.218-.017.144-.024.303-.058l.22-.044c.18-.033.36-.056.514-.035.153.021.338.093.528.177l.191.085c.13.06.258.118.38.165.184.071.346.115.468.098q.091-.011.146-.07a.34.34 0 0 0 .076-.19.82.82 0 0 0-.127-.523 1.9 1.9 0 0 0-.421-.477c-.344-.287-.774-.494-1.069-.534s-.693.053-1.032.247-.612.485-.66.838Z"
    />
    <path
      stroke="#00265D"
      strokeLinecap="round"
      strokeWidth={1.176}
      d="M5.294 13.53S6.912 15 10 15s4.706-1.47 4.706-1.47"
    />
  </svg>
);
export default SvgHappyEmotion;
